var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverviewUnderlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 938,
    height: 249,
    viewBox: "0 0 938 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1744_53176)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 938,
    height: 249,
    rx: 8,
    fill: "#0072CE",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.0715,
    height: 593.101,
    transform: "matrix(0.800133 -0.599822 0.684608 0.728912 146.666 144.724)",
    fill: "#0072CE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.0715,
    height: 593.101,
    transform: "matrix(0.800133 -0.599822 0.684608 0.728912 196.569 100.463)",
    fill: "#0072CE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.0715,
    height: 593.101,
    transform: "matrix(0.800133 -0.599822 0.684608 0.728912 246.473 56.202)",
    fill: "#0072CE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.0715,
    height: 593.101,
    transform: "matrix(0.800133 -0.599822 0.684608 0.728912 296.376 11.9406)",
    fill: "#0072CE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.0715,
    height: 593.101,
    transform: "matrix(0.800133 -0.599822 0.684608 0.728912 346.279 -32.3202)",
    fill: "#0072CE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.0715,
    height: 593.101,
    transform: "matrix(0.800133 -0.599822 0.684608 0.728912 446.086 -120.434)",
    fill: "#0072CE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.0715,
    height: 593.101,
    transform: "matrix(0.800133 -0.599822 0.684608 0.728912 545.893 -208.543)",
    fill: "#0072CE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.0715,
    height: 593.101,
    transform: "matrix(0.800133 -0.599822 0.684608 0.728912 396.183 -76.5817)",
    fill: "#0072CE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.0715,
    height: 593.101,
    transform: "matrix(0.800133 -0.599822 0.684608 0.728912 495.989 -164.696)",
    fill: "#0072CE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.0715,
    height: 593.101,
    transform: "matrix(0.800133 -0.599822 0.684608 0.728912 595.796 -252.803)",
    fill: "#0072CE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1744_53176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 938,
    height: 249,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewUnderlay);
export default __webpack_public_path__ + "static/media/overview_underlay.c5a4f7360178184131d457bb25e357c6.svg";
export { ForwardRef as ReactComponent };